import { Component, NgModule, OnInit } from '@angular/core';
import { ActivatedRouteSnapshot, Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { HttpService } from './core/http.service';

@Component({
    selector: 'app-root',
    template: `
    <router-outlet></router-outlet>

  `
})
export class AppComponent implements OnInit {

    constructor(
        private router: Router,
     
    ) {


    }

    ngOnInit() {
       
    }


}
declare var $: any;
declare var olleh : any;
declare var gtag : any;